export enum BillingChargeType {
  COPAY = 'copay',
  COINSURANCE = 'coinsurance',
  DEDUCTIBLE = 'deductible',
  SELF_PAY = 'self_pay',
  NO_SHOW = 'no_show',
  EAP = 'eap',
  VA = 'va',
  PENDING_CLAIM = 'pending_claim',
  PENDING_CLAIM_WITH_ESTIMATE = 'pending_claim_with_estimate',
  CLAIM_DENIED = 'claim_denied',
  UNKNOWN = 'unknown',
}

export enum ClaimState {
  PENDING = 'pending',
  PROCESSED = 'processed',
  COVERED = 'covered',
  PAST_DUE = 'past_due',
}

export enum PaymentStatus {
  PAID = 'paid',
  UPCOMING = 'upcoming',
  PAST_DUE = 'past_due',
}

export interface IClientBillingClaim {
  id: string;
  superBillId: string;
  personaClientId: number;
  sessionDate: Date;
  providerName: string;
  primaryInsuranceName: string;
  secondaryInsuranceName: string | null;
  claimState: ClaimState;
  chargeType: BillingChargeType;
  isCovered: boolean;
  amountBilled: number;
  insurancePaid: number;
  patientResponsibility: number;
  copayLabel: string | null;
  deductibleAmount?: number;
  deductibleApplied?: number;
  deductibleRemaining?: number;
  denialReason: string | null;
  cptCodes: string[];
  paymentStatus: PaymentStatus | null;
  paymentMethodBrand: string | null;
  paymentMethodLast4: string | null;
  accountPaymentMethodId: string | null;
  scheduledPaymentDate: Date | null;
  claimSubmittedAt: Date | null;
  partOfPaymentPlan: boolean;
}
